export default __webpack_public_path__ + "static/ak-cached/24h/media/desk-spring-flash-sale-hero.94bcf150.jpg";